'use client';

import { BlogProvider } from '@/context/BlogContext';
import BlogPageComponent from '../BlogPageComponent';

export const BlogPageClient = ({ initialData }) => {
  return (
    <BlogProvider initialData={initialData}>
      <BlogPageComponent />
    </BlogProvider>
  );
};
